// The support record of a vulnerability assessment (SEP-293 section 7).
//
// "Retain a separate explicit Vulnerability assessment, outcome and support
// requirement record. Allow the IM/EA to record communication needs, support
// needs and any required adjustments." The outcome lives in
// `internal-review-branches.ts`; this module holds the closed list of the
// communication needs. UNCONFIRMED DEFAULT: the firm has not agreed the list.

export const VULNERABILITY_COMMUNICATION_NEED_VALUES = [
    'large_print',
    'audio',
    'extra_time',
    'plain_language',
    'third_party_present',
    'other',
] as const;
export type VulnerabilityCommunicationNeed =
    (typeof VULNERABILITY_COMMUNICATION_NEED_VALUES)[number];

/** The words of each communication need. UI copy, for the approval of the user. */
export const VULNERABILITY_COMMUNICATION_NEED_LABELS = Object.freeze(
    Object.fromEntries([
        ['large_print', 'Large print'],
        ['audio', 'Audio'],
        ['extra_time', 'Extra time'],
        ['plain_language', 'Plain language'],
        ['third_party_present', 'A third party present'],
        ['other', 'Other'],
    ]),
) as Readonly<Record<VulnerabilityCommunicationNeed, string>>;
